import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../api/api';
import { HistoryType, SpotDetailType } from '../types/HistoryType';
import { components } from '../components';
import {svg} from '../assets/svg';
import closeImg from '../assets/icons/check-none-colored.png';

interface Props {
  history: HistoryType;
  isOpen: boolean;
  onClose: () => void;
}

export const HistoryDetailModal: React.FC<Props> = ({ history, isOpen, onClose }) => {
  const [currentSpotIndex, setCurrentSpotIndex] = useState<number>(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCurrentSpotIndex(0);
      setSelectedImageIndex(0);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const currentSpot: SpotDetailType = history.spotDetails[currentSpotIndex] || {
    id: '',
    spotName: 'No Spot Data',
    scannedTime: '',
    notes: 'Tidak ada data',
    photos: [],
    scannedBy: 'Unknown',
    status: 'pending'
  };

  const canGoPrevious = currentSpotIndex > 0;
  const canGoNext = currentSpotIndex < history.spotDetails.length - 1;

  const handlePrevious = () => {
    if (canGoPrevious) {
      setCurrentSpotIndex(prev => prev - 1);
      setSelectedImageIndex(0);
    }
  };

  const handleNext = () => {
    if (canGoNext) {
      setCurrentSpotIndex(prev => prev + 1);
      setSelectedImageIndex(0);
    }
  };

  return (
    <>
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex',
        alignItems: 'center', justifyContent: 'center', zIndex: 1000,
        padding: '16px'
      }}>
        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '16px', 
          width: '100%', 
          maxWidth: '480px', 
          maxHeight: '85vh', 
          overflow: 'auto', 
          position: 'relative',
          boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)'
        }}>
          
          <button 
            onClick={onClose} 
            className='t16'
            style={{ 
              position: 'absolute',
              top: '16px', 
              right: '16px', 
              background: 'rgb(230, 243, 248)',
              // border: '2px solid rgba(255,0,0,0.4)',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              zIndex: 10,
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = 'rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#333';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'rgba(0,0,0,0.1)';
              e.currentTarget.style.color = '#666';
            }}
          >
            {/* <svg.RemoveModalSvg /> */}
            <img src={closeImg} className='img-fluid' alt="" width={25} height={25} style={{opacity:0.7}}/>
          </button>

          {/* {history.spotDetails.length > 1 && (
            <>
              <button 
                onClick={handlePrevious}
                disabled={!canGoPrevious}
                style={{ 
                  position: 'absolute',
                  top: '50%',
                  left: '16px',
                  background: canGoPrevious ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.3)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: canGoPrevious ? 'pointer' : 'not-allowed',
                  fontSize: '20px',
                  color: 'white',
                  zIndex: 10,
                  transform: 'translateY(-50%)',
                  transition: 'all 0.2s ease'
                }}
              >
                ‹
              </button>
              
              <button 
                onClick={handleNext}
                disabled={!canGoNext}
                style={{ 
                  position: 'absolute',
                  top: '50%',
                  right: '16px',
                  background: canGoNext ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.3)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: canGoNext ? 'pointer' : 'not-allowed',
                  fontSize: '20px',
                  color: 'white',
                  zIndex: 10,
                  transform: 'translateY(-50%)',
                  transition: 'all 0.2s ease'
                }}
              >
                ›
              </button>
            </>
          )} */}

          <div style={{ padding: '20px' }}>
            <div>
              <h3 style={{ 
                marginBottom: '4px', 
                fontWeight: '600',
                width:'90%'
              }}>
                {history.patrolName}
              </h3>
              
              <p className="t12" style={{ margin: '4px 0', width:'90%'}}>
                {history.date} • {history.groupName}
              </p>
              <div style={{padding:10}}>
                <div className='row-center-space-between'
                  style={{margin:"10px 0 10px"}}
                >
                  <p className="t14" style={{ 
                    fontWeight: 'bold', 
                  }}>
                    Jam Mulai: 
                  </p>
                  <p className="t14" style={{ 
                    fontWeight: 'bold', 
                    color: '#059669',
                  }}>
                    {history.clockIn}
                  </p>
                </div>
              </div>
            </div>

            <div style={{ padding: '15px', borderRadius:10, backgroundColor:"rgba(233,255,255,0.4)" }}>
              
              {history.spotDetails.length > 1 && (
                <div className='row-center-space-between' style={{marginBottom:40}}>
                  <button 
                    onClick={handlePrevious}
                    disabled={!canGoPrevious}
                    style={{ 
                      position: 'relative',
                      background: canGoPrevious ? 'rgba(0,176,185,1)' : 'rgb(230, 243, 248)',
                      borderRadius: '6px',
                      cursor: canGoPrevious ? 'pointer' : 'not-allowed',
                      fontSize: '18px',
                      color: 'white',
                      zIndex: 10,
                      transition: 'all 0.2s ease',    
                      fontFamily: 'DM Sans, sans-serif',
                      padding: "8px 15px",
                      lineHeight: 1
                    }}
                  >
                    &#10094;
                  </button>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '8px 12px',
                    backgroundColor: '#fff',
                    border:"1px solid var(--main-turquoise)",
                    borderRadius: '8px',
                    width:"100%",
                    margin:"0 10px"
                  }}>
                    <span className='t12'>
                      Spot {currentSpotIndex + 1} of {history.spotDetails.length}
                    </span>
                    <span className='t12' style={{ 
                      color: '#059669',
                      fontWeight: '500'
                    }}>
                      {history.completedSpots}/{history.totalSpots} selesai
                    </span>
                  </div>
                  <button 
                    onClick={handleNext}
                    disabled={!canGoNext}
                    style={{ 
                      position: 'relative',
                      background: canGoNext ? 'rgba(0,176,185,1)' : 'rgb(230, 243, 248)',
                      borderRadius: '6px',
                      cursor: canGoNext ? 'pointer' : 'not-allowed',
                      fontSize: '18px',
                      color: 'white',
                      zIndex: 10,
                      transition: 'all 0.2s ease',    
                      fontFamily: "Poppins, sans-serif",
                      padding: "8px 15px",
                      lineHeight: 1
                    }}
                  >
                    &#10095;
                  </button>
                </div>
              )}

              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'flex-start',
                marginBottom: '10px'
              }}>
                <div style={{ flex: 1 }}>
                  <h4 className='t16' style={{fontWeight:600}}>
                    {currentSpot.spotName}
                  </h4>
                </div>
                <span className='t12' style={{
                  padding: '4px 8px',
                  borderRadius: '4px',
                  backgroundColor: currentSpot.status === 'scanned' ? 'var(--main-turquoise)' : '#f59e0b',
                  color: 'white',
                  fontWeight: '500',
                  flexShrink: 0
                }}>
                  {currentSpot.status === 'scanned' ? 'Terscan' : 'Pending'}
                </span>
              </div>

              <div 
                style={{
                  display:'grid',
                  gridTemplateColumns:'auto 1fr',
                  gap:10,
                  marginBottom:20
                }}
              >
                <div style={{ 
                  padding: '10px',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  border: '1px solid rgba(0,176,185,0.25)',
                  maxWidth:125
                }}>
                  <p className='t12' style={{ 
                      marginBottom: '4px', 
                    }}>
                    Di-scan pada: 
                  </p>
                  <p className='t14' style={{
                    color: 'var(--main-turquoise)',
                  }}>{currentSpot.scannedTime}
                  </p>
                </div>

                {currentSpot.scannedBy && (
                  <div style={{ 
                    padding: '10px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    border: '1px solid rgba(0,176,185,0.25)',
                  }}>
                    <p className='t12' style={{ 
                      marginBottom: '4px', 
                    }}>
                      Di-scan oleh:
                    </p>
                    <p className='t12' style={{ 
                      margin: 0, 
                      color: 'var(--main-turquoise)',
                    }}>
                      {currentSpot.scannedBy}
                    </p>
                  </div>
                )}
              </div>
              
              {currentSpot.photos.length > 0 && (
                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ 
                    marginBottom: '12px', 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Bukti Foto ({currentSpot.photos.length})
                  </h4>
                  <img
                    src={currentSpot.photos[selectedImageIndex]}
                    alt={`Evidence ${selectedImageIndex + 1}`}
                    style={{ 
                      width: '100%', 
                      height: '200px', 
                      objectFit: 'cover', 
                      borderRadius: '8px', 
                      cursor: 'pointer',
                      border: '1px solid #e5e7eb'
                    }}
                    onClick={() => setIsImageModalOpen(true)}
                  />
                  {currentSpot.photos.length > 1 && (
                    <div style={{ 
                      display: 'flex', 
                      gap: '8px', 
                      marginTop: '12px',
                      overflowX: 'auto',
                      paddingBottom: '4px'
                    }}>
                      {currentSpot.photos.map((photo, i) => (
                        <img
                          key={i}
                          src={photo}
                          alt={`Thumbnail ${i + 1}`}
                          style={{
                            width: '60px',
                            height: '60px',
                            objectFit: 'cover',
                            border: selectedImageIndex === i ? '3px solid #10b981' : '2px solid #e5e7eb',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            flexShrink: 0
                          }}
                          onClick={() => setSelectedImageIndex(i)}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}

              {currentSpot.notes && currentSpot.notes !== '-' && (
                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ 
                    marginBottom: '8px', 
                    fontSize: '16px', 
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Catatan
                  </h4>
                  <div>
                    <p className='t14' style={{ 
                      margin: 0, 
                      whiteSpace: 'pre-wrap',
                      lineHeight: '1.5'
                    }}>
                      {currentSpot.notes}
                    </p>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>

      <components.ImageModal
        photos={currentSpot.photos}
        isOpen={isImageModalOpen}
        onClose={() => setIsImageModalOpen(false)}
      />
    </>
  );
};